import { render } from "./SidebarPage.vue?vue&type=template&id=17bd03da"
import script from "./SidebarPage.vue?vue&type=script&lang=js"
export * from "./SidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__